<template>
  <div class="component-cards">
    <div class="filter">
    <p class="filter-text">See destinations where: </p>
    <div class="filter-items">
    <button @click="filterClick(1)" :class="['filter-item', {active: activeFilter.includes(1)}]" ref="btn1"><img src="assets/images/icons/icon_virus-green.svg" class="icon-filter"/>Covid-19 cases are falling<img src="assets/images/icons/close-white.svg" class="remove-filter"/>
      </button>
    <button @click="filterClick(2)" :class="['filter-item', {active: activeFilter.includes(2)}]" ref="btn2"><img src="assets/images/icons/icon_vaccine-green.svg" class="icon-filter"/>Vaccination rates are high<img src="assets/images/icons/close-white.svg" class="remove-filter"/></button>
    <button @click="filterClick(3)" :class="['filter-item', {active: activeFilter.includes(3)}]" ref="btn3"><img src="assets/images/icons/icon_check-green.svg" class="icon-filter"/>No quarantine is required<img src="assets/images/icons/close-white.svg" class="remove-filter"/></button>
    <!-- <button @click="filterClick(0)" :class="['filter-item', {active: activeFilter.includes(0)}]" ref="btn0">See all</button> -->
    </div>
    </div>
    <div class="cards-container">
    <div v-for="(item, key) in filteredData" :key="key" class="card" :id=" `card-` + key">
          <img src="assets/images/icons/icon_flight.svg" class="flag"/>
      <h3 class="destination">{{item.destination}}</h3>
      <div class="inner-card">
        <div class="section-restrictions section">
          <h4><a :href="`${item.mfa_link}`">Travel restrictions</a></h4>
            <img :src="getIcon(item.vtl_svg)" class="icon"/>
            <p class="with-icon" v-html="item.quarantine">.</p>
          <!-- <p class="child">{{item.vtl}}</p> -->
          <!-- <p class="child">{{item.quarantine}}.</p> -->
          <p class="child" v-if="item.covid_testing">{{item.covid_testing}}.</p>
        </div>
        <div class="section-covid section">
          <h4><a :href="`${item.reuters}`">National Covid-19 situation</a></h4>
          <img :src="getIcon(item.risk_level_svg)" class="icon"/>

          <p class="with-icon">Covid-19 cases are <strong>{{item.covid_cases_trend}}</strong>.</p>
          <p class="child"><strong>{{(item.covid_rate_val).toFixed(0)}}</strong> average daily {{item.case_or_cases}} per 1m people in the last week.</p>
          <div class="section-head">
            <img :src="getIcon(item.vaccination_rate_svg)" class="icon"/>
            <p class="with-icon">Vaccination rate is <strong>{{item.vaccination_rate}}.</strong></p>
          </div>
          <p class="child"><strong>{{(item.vaccination_rate_val).toFixed(0)}}</strong> people fully vaccinated per 100.</p>

        </div>
        <div class="section-trends section">
          <h4>Compared with Dec 2020...</h4>
            <img src="assets/images/icons/icon_seat.svg" class="icon"/>

          <p class="with-icon seat-capacity">{{item.seats_text}}.</p>
          <div>
          <img src="assets/images/icons/icon_flight.svg" class="icon"/>

          <p class="with-icon">{{item.freq_text}}.</p>
        </div>
          <!-- <p>{{item.travel_restriction_level}} restrictions</p>
          <p>{{item.vtl}}</p>
          <p>{{item.quarantine}}</p>
          <p>{{item.testing}}</p> -->
        </div>
      </div>
      </div>
      </div>
      <div class="toggle-wrapper" ref="togglecontainer">
      <button v-if="activeFilter == 0" @click="toggleSeeMore" ref="toggle" class="toggle-button" v-html="textButton"></button>
      </div>
  </div>
</template>

<script>
import { debounce, throttle } from "lodash";
import filter from 'lodash/filter'


export default {
  props: ['attributes'],
  computed: {
    content () {
      return this.attributes.value
    },
      isMobileWidth () {
      // return this.$window.innerWidth < 420 || this.$window.innerHeight < 420;
      return this.$window.innerWidth < 426
    },
    textButton () {
      if (this.isAllShown) {
        return "- See less destinations"
      } else if (!this.isAllShown) {
        return "+ See all 15 destinations"
      }
    }

  },
  data() {
    return {
      dataJson: {},
      feedData: [],
      filteredData: [],
      activeFilter: [],
      isAllShown: true,
    
    }
  },
  mounted() {
     this.getData();
  },
  methods: {
    getData() {
      const resourceEndpoint =
        (process.env.APP_NODE_ENV || process.env.NODE_ENV) === "production"
          ? "https://www.straitstimes.com/multimedia/graphics/json/"
          : "https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/";

      const url =
        resourceEndpoint + this.attributes.value.dataurl + ".json";
      fetch(url)
        .then((res) => res.json())
        .then((jsonkeydata) => {
          if (!jsonkeydata) return;

          this.feedData = jsonkeydata;
          this.filteredData = jsonkeydata;

          if (this.isMobileWidth) {
            this.filteredData = jsonkeydata.slice(0, 3);
            this.isAllShown = false;
          }

        })
    },
    getIcon (value) {
      if (!value) return null
      return require(`images/icons/${value}`)
    },
    filterClick (value) {
      var self = this;

      if (!this.activeFilter.includes(value)) {
          this.activeFilter.push(value);
      } else if (this.activeFilter.includes(value)) {
        var index = self.activeFilter.indexOf(value)
        if (index > -1) { self.activeFilter.splice(index, 1) }
      }

      if (this.activeFilter.length === 0) {
          this.isAllShown = true;
      }

 
      const condition1 = this.activeFilter.includes(1)

      const condition2 = this.activeFilter.includes(2)

      const condition3 = this.activeFilter.includes(3)


      const filterConditions = {
        ...(condition1) && {risk_level_svg: "icon_virus-green.svg"},
        ...(condition2) && {vaccination_rate: "high"},
        ...(condition3) && {quarantine_days: 0},
      }

    this.filteredData = this.feedData.filter(function(item) {
        for (var key in filterConditions) {
          if (item[key] === undefined || item[key] != filterConditions[key])
            return false;
        }
        return true;
      });

      // if (this.activeFilter.includes(value)) {
      //   var condition = "condition" + value;
      //   var currentCondition = Object.assign(condition1)
      //   console.log(currentCondition);
      // }
      // if (value === 0) {
      //   this.filteredData = this.feedData
      //   this.isAllShown = true;
      // } else if (value === 1) {
      //   this.filteredData = filter(this.feedData, function(item){
      //     return item.covid_cases_trend.toLowerCase().trim() === 'falling';
          
      //     });
      // } else if (value === 2) {
      //     this.filteredData = filter(this.feedData, function(item){
      //     return item.vaccination_rate.toLowerCase().trim() === 'high';
          
      //     });
      // } else if (value === 3) {
      //     this.filteredData = filter(this.feedData, function(item){
      //     return item.is_vtl.toLowerCase().trim() === 'yes';
          
      //     });
      // }
    },
    // hideRestOnMobile() {
    //   if (!this.isMobileWidth) return;
    //   const allCards = this.$el.getElementsByClassName("card")

    // },
    toggleSeeMore() {
      if (!this.isMobileWidth) return;
      const btnEl = this.$refs.toggle;
      const lastCard = document.getElementById('card-2');
      if(!this.isAllShown) {
      this.filteredData = this.feedData;
      this.isAllShown = true;
      //  btnEl.innerHTML = "- See less destinations";
      }

      else if (this.isAllShown){
        this.filteredData = filter(this.feedData, function(item){
          return item.id <= 3
          
          });
        this.isAllShown = false;
        //  btnEl.innerHTML = "+ See all 15 destinations";
         lastCard.scrollIntoView();
       
      }
  },
  }

}
</script>

<style lang="scss">
.component-cards {
    margin: 0 auto;
    text-align: left;
    display: block;
}
.cards-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: block;
    text-align: left;
    @media (max-width: 624px) {
      text-align: center;
    }
    @media (min-width: 625px) and (max-width: 903px) {
      max-width: 600px;
    }
    @media (min-width: 904px) and (max-width: 1199px) {
      max-width: 900px;
    }
}
    .card {
        // box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);

      border: 1px solid #c9d0d1;
      background-color: #E6EDEE;
      border-radius: 10px;
      font-size: 16px;
      width: 275px;
      height: 415px;
      position: relative;
      vertical-align:top;
      text-align: left;
      display: inline-block;
      margin: 10px;
      overflow: hidden;
      
      @media (max-width: $d_small) {

          width: calc(100vw - 32px);

      }

      .flag {
        height: 19px;
        margin: 10px;
        float: left;
      }

      p {
        font-family: $font-CuratorRegular;
        font-size: 15px;
        line-height: 20px;
        // margin: 7px 0
        &.child {
          margin-left: 20px;
        }
        strong {
          font-family: $font-CuratorBold;
        }
      }

     h3.destination {
      display: inline-block;
      margin: 4px 0;
      font-family: $font-CuratorBold !important;
      font-size: 17px;
     } 

     .inner-card {
       background: white;
       padding: 5px 10px 5px 12px;
       height: 350px;
       .icon {
         height: 13px;
         display: inline;
         margin-right: 5px;
         margin-top: 5px;
       }

       .section-head {
         margin-top: 7px;
       }

       .with-icon {
         display: inline;
        //  margin-top: 0px !important;
        margin-left: 2px;
        // margin-top: 10px;
        &.seat-capacity {
          margin-left: 4px;
        }
       }
     }

     h4 {
       font-size: 13px;
       line-height: 25px;
       margin-top: 5px;
       font-family: $font-CuratorRegular;
       text-transform: uppercase;
       color: #676767;

        a {
          color: #999999;
          &:hover {
            border-bottom: 1px dotted rgba(114,127,142,.5);

          }
        }
     }

    }

    .filter {
       margin: 0 auto;
       max-width: 700px;
       padding: 16px;
      //  text-align: center;
      p{
        font-family: $font-CuratorRegular;
        font-size: 15px;
      }

      button {
        font-family: $font-CuratorRegular;
        font-size: 15px;
            // display: inline-block;
        padding: 3px 0 3px 7px;
        border: 1px solid #c9d0d1;
        background-color: #E6EDEE;
        color: #333333;
        border-radius: 20px;
        cursor: pointer;
        // opacity: .8;
        margin-right: 7px;
        margin-bottom: 10px;
        transition: 0.3s;

        img.remove-filter {
            opacity: 0;
            height: 10px;
            width: 10px;
            padding: 0 7px 0 3px;

        }

        img.icon-filter {
            // opacity: 0;
            height: 12px;
            width: 12px;
            padding: 0 5px;

        }

        @media (min-width: 768px) {
        &:hover {
          background-color: $stblue;
          color: white;

        }
        }

        &.active {
        // background-color: rgba(114,127,142,.5);
        //  cursor: unset;
        background-color: $stblue;
        color: white;
        img.remove-filter {

          // display: inline-block;
          // margin-right: 5px;
          opacity:1
  
        }


        }
        // &.active:after {
        //   content: "";
        //   background: url("~images/icons/close-white.svg") no-repeat 50%;
        //   background-size: contain;
        //   width: 10px;
        //   height: 10px;
        //   display: inline-block;
        //   position: absolute;
        //   right: 10px;
        //   top: 50%;
        //   -webkit-transform: translateY(-50%);
        //   transform: translateY(-50%);
        // }
      }
      .filter-text {
        display: inline-block;
        margin-right: 5px;
        color: #9e9e9e
      }
      
      .filter-items {
        display: inline-block;
      }
     }

     .component {
       &.component-destinationcards {
         padding:  0px !important;
       }
     }

     .section-restrictions, .section-covid {
       padding-bottom: 10px;
       border-bottom: 1px dotted rgba(114,127,142,.5);
     }
     

      .toggle-button {
        display: block;
       @media (min-width: 426px) {
         display: none;

       }
       margin: 0 auto;
       text-align: center;
       font-family: $font-CuratorRegular;
       color: #333333;
      //  border: none;
      //  background: none;
       font-size: 15px;
        border: 1px solid #c9d0d1;

        background-color: #E6EDEE;
        border-radius: 20px;
        padding: 3px 12px;

      //  &:hover {
      //    text-decoration: underline;
      //  }
       
     }

     .smaller {
       font-size: 12px;
     }
</style>